import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SegmentsSearch",
  props: {
    searchString: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      currentSearchString: ""
    };
  },
  watch: {
    searchString: {
      immediate: true,
      handler() {
        this.currentSearchString = this.searchString;
      }
    }
  },
  methods: {
    handleSearch: debounce(function (text) {
      this.$emit("search-contacts", _trimInstanceProperty(text).call(text));
    }, 300)
  }
});